module.exports = __webpack_public_path__ + "static/media/ios-cloud-circle.01614362.svg";